<template>
  <div>
    <h2>Мои спецпредложения</h2>

    <div class="row">
      <div class="col-lg-10">
        <div
          class="row status"
        >
          <div class="col-sm-6 col-md-4">
            <p class="status-label">
              Ваш статус:
            </p>
            <div class="status-card active">
              <template v-if="!clientInfoFetching">
                <template v-if="clientInfo.loyalty_status">
                  <img
                    :src="require(`../../img/status_${clientInfo.loyalty_status}.png`)"
                    :alt="`Status ${clientInfo.loyalty_status}`"
                    class="status-img"
                  >
                  <span class="status-name">{{ clientInfo.loyalty_status | capitalizeFirstLetter }}</span>
                  <img
                    src="../../img/special-offer/status-current.png"
                    alt="Current status"
                    class="status-current"
                  >
                </template>
                <no-data v-else />
              </template>
              <c-spinner v-else />
            </div>
          </div>
          <template v-if="isClientStatusCanBeUpgraded">
            <div class="col-sm-6 col-md-4">
              <p class="status-label">
                Следующий статус:
              </p>
              <div class="status-card">
                <template v-if="!loyaltyProgramMapFetching && loyaltyProgramMapNextStep.status">
                  <img
                    :src="require(`../../img/status_${loyaltyProgramMapNextStep.status}.png`)"
                    :alt="`Status ${loyaltyProgramMapNextStep.status}`"
                    class="status-img"
                  >
                  <span class="status-name">{{ loyaltyProgramMapNextStep.status | capitalizeFirstLetter }}</span>
                </template>
                <c-spinner v-else />
              </div>
            </div>
            <div class="col-sm-12 col-md-4 change-status-btn-container">
              <button
                type="button"
                data-toggle="modal"
                :data-target="'#' + $getConst('FORM_MAIL_ORDER_MODAL_ID')"
                class="btn btn-warning change-status-btn"
              >
                Изменить статус
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>

    <h3>Ваши скидки</h3>

    <template v-if="!loyaltyProgramMapFetching">
      <template v-if="getPrivilegesConnected($getConst('PRIVILEGE_TYPE_DISCOUNT')).length">
        <discount
          v-for="privilege in getPrivilegesConnected($getConst('PRIVILEGE_TYPE_DISCOUNT'))"
          :key="privilege.id"
          :current="privilege.value"
          :next="getNextStepPrivilege(privilege.symbol_name) ? getNextStepPrivilege(privilege.symbol_name).value : 0"
          :title="privilege.title"
          :description="privilege.description"
        />
      </template>
      <no-data v-else />
    </template>
    <c-spinner v-else />

    <div>
      <h3>Подключенные привилегии</h3>

      <div class="overlay-wrapper">
        <div class="row">
          <carousel
            :per-page="6"
            :per-page-custom="[[320, 1], [768, 3], [1024, 6]]"
            :navigation-enabled="true"
            :navigation-click-target-size="0"
            :pagination-enabled="false"
            :scroll-per-page="false"
          >
            <slide
              v-for="item in privilegesConnectedServices"
              :key="item.id"
            >
              <div style="padding: 15px; height: 100%">
                <privilege
                  :symbol-name="item.symbol_name"
                  :title="item.title"
                  :description="item.description"
                  :period="item.period"
                />
              </div>
            </slide>
          </carousel>
        </div>
        <c-loading-overlay v-if="loyaltyProgramMapFetching" />
      </div>
    </div>

    <div class="margin-bottom">
      <h3>Привилегии, которые можно получить</h3>

      <div class="overlay-wrapper">
        <div class="row">
          <carousel
            :per-page="6"
            :per-page-custom="[[320, 1], [768, 3], [1024, 6]]"
            :navigation-enabled="true"
            :navigation-click-target-size="0"
            :pagination-enabled="false"
            :scroll-per-page="false"
          >
            <slide
              v-for="item in privilegesNotConnectedServices"
              :key="item.id"
            >
              <div style="padding: 15px; height: 100%">
                <privilege
                  :connected="false"
                  :symbol-name="item.symbol_name"
                  :title="item.title"
                  :description="item.description"
                  :period="item.period"
                />
              </div>
            </slide>
          </carousel>
        </div>
        <c-loading-overlay v-if="loyaltyProgramMapFetching" />
      </div>
    </div>

    <template v-if="!loyaltyProgramMapFetching">
      <div
        v-if="loyaltyProgramMapNextStep.status"
        class="row"
      >
        <div class="col-lg-4 privilege-lead">
          <h1>Хотите получить больше привилегий?</h1>
          <!-- TODO: в conditions может быть разделитель "|", который надо учитывать при выводе -->
          <p
            class="conditions"
            v-html="loyaltyProgramMapNextStepConditionsFormated"
          />
          <button
            type="button"
            data-toggle="modal"
            :data-target="'#' + $getConst('FORM_MAIL_ORDER_MODAL_ID')"
            class="btn btn-warning margin-bottom"
          >
            Изменить статус
          </button>
        </div>
        <div class="col-lg-8">
          <template v-if="getNextStepPrivilegesWithoutDiscount.length">
            <div class="row privileges next-step-privileges">
              <div
                v-for="privilege in getNextStepPrivilegesWithoutDiscount"
                :key="privilege.id"
                class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
              >
                <privilege
                  lead
                  :symbol-name="privilege.symbol_name"
                  :title="privilege.title"
                  hide-btn
                />
              </div>
            </div>
          </template>
          <no-data v-else />
        </div>
      </div>
    </template>
    <c-spinner v-else />
  </div>
</template>

<script>
import Discount from '../components/views/specialOffer/Discount'
import Privilege from '../components/views/specialOffer/Privilege'
import NoData from '../components/NoData'
import { mapActions, mapGetters, mapState } from 'vuex'
import CSpinner from '../components/ui/CSpinner'
import grid from '../mixins/grid'
import CLoadingOverlay from '../components/ui/CLoadingOverlay.vue'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'SpecialOffer',
  components: {
    CLoadingOverlay,
    CSpinner,
    Discount,
    Privilege,
    NoData,
    Carousel,
    Slide
  },
  mixins: [grid],
  computed: {
    /**
     * Подключенные привилегии-услуги.
     *
     * @returns {[]}
     */
    privilegesConnectedServices () {
      return this.getPrivilegesConnected(this.$getConst('PRIVILEGE_TYPE_SERVICE'))
    },
    /**
     * Неподключенные привилегии-услуги.
     *
     * @returns {[]}
     */
    privilegesNotConnectedServices () {
      return this.getPrivilegesNotConnected(this.$getConst('PRIVILEGE_TYPE_SERVICE'))
    },
    /**
     * @returns string
     */
    loyaltyProgramMapNextStepConditionsFormated () {
      return this.loyaltyProgramMapNextStep.conditions.replace('[|]ИЛИ[|]', '<br><br>ИЛИ<br><br>')
    },
    ...mapState({
      clientInfoFetching: state => state.seo.client.info.fetching,
      clientInfo: state => state.seo.client.info.client,
      loyaltyProgramMapFetching: state => state.seo.forms.loyaltyProgramMap.fetching,
      loyaltyProgramMapNextStep: state => state.seo.forms.loyaltyProgramMap.nextStep,
      domainSelected: state => state.seo.client.domains.selected
    }),
    ...mapGetters({
      isClientStatusCanBeUpgraded: 'seo/client/info/isStatusCanBeUpgraded',
      getPrivilegesConnected: 'seo/forms/loyaltyProgramMap/getPrivilegesConnected',
      getPrivilegesNotConnected: 'seo/forms/loyaltyProgramMap/getPrivilegesNotConnected',
      getNextStepPrivilege: 'seo/forms/loyaltyProgramMap/getNextStepPrivilege',
      getNextStepPrivilegesWithoutDiscount: 'seo/forms/loyaltyProgramMap/getNextStepPrivilegesWithoutDiscount'
    })
  },
  mounted () {
    if (this.domainSelected) {
      this.loyaltyProgramMapFetch()
    }
    this.$root.$on('clientDomainsSelectedChange', this.loyaltyProgramMapFetch)
  },
  destroyed () {
    this.$root.$off('clientDomainsSelectedChange', this.loyaltyProgramMapFetch)
  },
  methods: {
    loyaltyProgramMapFetch () {
      this.formsLoyaltyProgramMapFetch(this.domainSelected)
    },
    ...mapActions({
      formsLoyaltyProgramMapFetch: 'seo/forms/loyaltyProgramMap/fetch'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.status {
  &>div {
    @media (max-width: $xsBreakpoint) {
      margin-top: 10px;
    }
  }

  .change-status-btn-container {
    @media (max-width: $smBreakpoint) {
      text-align: center;
    }

    .change-status-btn {
      margin-top: 38px;

      @media (max-width: $smBreakpoint) {
        margin-top: 15px;
      }

      @media (max-width: $xsBreakpoint) {
        margin-top: 5px;
      }
    }
  }

  .status-label {
    font-weight: lighter;
    text-align: center;
    text-transform: uppercase;
  }

  .status-card {
    background-color: white;
    padding: 10px 20px;
    border-radius: $borderRadiusLarge;

    &.active {
      background-color: rgba(61, 181, 19, 0.15);
    }

    .status-img {
      padding-right: 10px;
    }

    .status-name {
      font-weight: bold;
      font-size: 1.2em;
    }

    .status-current {
      float: right;
      margin-top: 3px;
    }

  }
}

h3 {
  text-transform: uppercase;
}

.privileges {
  display: flex;
  flex-wrap: wrap;
}

h1 {
  margin-top: 0px;
}

.privilege-lead .conditions {
  font-size: 1.3em;
}

.next-step-privileges > div {
  padding: 15px;
}
</style>
